import { Component, Inject, Input, OnInit } from "@angular/core";
import { NB_DIALOG_CONFIG, NbDialogRef } from "@nebular/theme";
import { IntranetService } from "../../service/intranet.service";
import { ApproveRequestLoadedState, ApproveRequestLoadingErrorState, ApproveRequestLoadingState, DeclineRequestLoadedState, DeclineRequestLoadingErrorState, DeclineRequestLoadingState } from "../../service/intranet.state";
import { Store } from "../../../../../@core/store/store";

@Component({
  selector: "app-request-confirmation-dialog",
  templateUrl: "./request-confirmation-dialog.component.html",
  styleUrls: ["./request-confirmation-dialog.component.scss"]
})

export class RequestConfirmationDialogComponent implements OnInit {
  @Input() title: any;
  // title: any;
  @Input() reqData: any;

  @Input() action: string;

  loading: boolean = false;

  constructor(protected dialogRef: NbDialogRef<RequestConfirmationDialogComponent>, private intranetService: IntranetService, @Inject(NB_DIALOG_CONFIG) public config: any) {

  }

  ngOnInit() {

  }

  dismiss() {
    this.dialogRef.close();
  }

  confirm() {

    if (this.action == 'approve') {
      this.approveRequest();
    }

    if (this.action == 'decline') {
      this.declineRequest();
    }

    if (this.action == 'approveAll') {
      this.approveRequest();
    }
  }

  approveRequest() {
    const me = this;

    me.intranetService.approveRequest(this.reqData).subscribe(
      (state: Store.State) => {
        if (state instanceof ApproveRequestLoadingState) {
          this.loading = true;
          return;
        }
        if (state instanceof ApproveRequestLoadedState) {
          if (state) {
            this.loading = false;
            this.dialogRef.close(true);
          }
          return;

        }
      },
      (state: ApproveRequestLoadingErrorState) => {
        this.loading = false;
        return;
      }
    );
  }

  declineRequest() {

    const me = this;

    me.intranetService.declineRequest(this.reqData).subscribe(
      (state: Store.State) => {
        if (state instanceof DeclineRequestLoadingState) {
          this.loading = true;
          return;
        }
        if (state instanceof DeclineRequestLoadedState) {
          if (state) {
            this.loading = false;
            this.dialogRef.close(true);
          }
          return;

        }
      },
      (state: DeclineRequestLoadingErrorState) => {
        this.loading = false;
        return;
      }
    );
  }

}
